import axios from 'axios';
import { FormEvent, useEffect, useState } from "react";
import { useNavigate } from 'react-router-dom';
import { Button, Checkbox, CheckboxProps, Form, FormField, Icon, Modal, Popup, TextArea } from 'semantic-ui-react';
import EssentialStar from "../../components/EssentialStar/EssentialStar";
import "./style.css";
export interface InputCustomerInfoState {
  isEdit?: boolean; // 수정인지 아닌지
}

const daumAddressId = "daum-postcode"; // script가 이미 rending 되어 있는지 확인하기 위한 ID
const daumAddressIdSrc = "//t1.daumcdn.net/mapjsapi/bundle/postcode/prod/postcode.v2.js";

function InputCustomerInfo() {

  const [owner, setOwner] = useState<string>("");
  const [companySerial, setCompanySerial] = useState<string>("");
  const [phone, setPhone] = useState<string>("");
  const [address, setAddress] = useState<string>("");
  const [addressDetail, setAddressDetail] = useState<string>("");
  const [email, setEmail] = useState<string>("");
  const [postCode, setPostCode] = useState<string>("");
  const [receiptName, setReceiptName] = useState<string>("");
  const [isInfoAgree, setIsInfoAgree] = useState<boolean>(false);
  const [rememberMyInfo, setRememberMyInfo] = useState<boolean>(false);
  const [isOwnerShake, setIsOwnerShake] = useState(false);
  const [isAddressShake, setIsAddressShake] = useState(false);
  const [isReceiptNameShake, setIsReceiptNameShake] = useState(false);
  const [isPhoneShake, setIsPhoneShake] = useState(false);
  const [isEmailShake, setIsEmailShake] = useState(false);
  const [isCompanySerialShake, setIsCompanySerialShake] = useState(false);
  const [isInfoShake, setIsInfoShake] = useState(false);
  const [isCompany, setIsCompany] = useState<string>('company');
  const [isValidCompanyRegisterNumber, setIsValidCompanyRegisterNumber] = useState<Boolean>(false);
  const [isRegistered, setIsRegistered] = useState<Boolean>(false)
  const [isUploadCompnaySerial, setIsUploadCompanySerial] = useState<Boolean>(false)
  const apiEndpoint = process.env.REACT_APP_API_ENDPOINT;
  const [closedDays, setClosedDays] = useState<string[]>([]);
  const [open, setOpen] = useState(false); // 모달 상태 관리
  const [paymentOpen, setPaymentOpen] = useState(true); // 모달 상태 관리
  const [isPaymentAgree, setIsPaymentAgree] = useState(false); // 모달 상태 관리
  const [customerRequest, setCustomerRequest] = useState<string>("");

  const navigate = useNavigate();
  const handleNextButtonClick = () => {
    // 여기에 입력값 유효성 검사 등 다음으로 넘어갈 조건을 체크하는 로직을 추가할 수 있습니다.
    if (!owner) {
      setIsOwnerShake(true);
      alert("고객명/ 상호명을 입력해주세요.")
      setTimeout(() => {setIsOwnerShake(false);}, 500)
      return;
    }

    const isCompanySerialValid = companySerial.length === 10 && /^\d+$/.test(companySerial);
    if (!isCompanySerialValid && isCompany === 'company') {
      setIsCompanySerialShake(true);
      alert("올바른 사업자등록번호를 입력해주세요.")
      setTimeout(() => {setIsCompanySerialShake(false);}, 500)
      return;
    }

    if (!email) {
      setIsEmailShake(true);
      alert("이메일을 입력해주세요.")
      setTimeout(() => {setIsEmailShake(false);}, 500)
      return;
    }

    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    if (!emailRegex.test(email)) {
      setIsEmailShake(true); // 애니메이션 트리거
      alert("유효한 이메일 주소가 아닙니다.");

      setTimeout(() => {
        setIsEmailShake(false); // 애니메이션 리셋
      }, 500);
      return;
    }

    if (!phone) {
      setIsPhoneShake(true);
      alert("연락처를 입력해주세요.")
      setTimeout(() => {setIsPhoneShake(false);}, 500)
      return;
    }

    if (!receiptName) {
      setIsReceiptNameShake(true);
      alert("접수자 이름을 입력해주세요.")
      setTimeout(() => {setIsReceiptNameShake(false);}, 500)
      return;
    }

    if (!address) {
      setIsAddressShake(true);
      alert("주소를 입력해주세요.")
      setTimeout(() => {setIsAddressShake(false);}, 500)
      return;
    }


    if (!isInfoAgree) {
      setIsInfoShake(true); // 애니메이션 트리거
      alert("개인정보제공동의란을 체크 해주세요 :)");

      setTimeout(() => {
        setIsInfoShake(false); // 애니메이션 리셋
      }, 500);
      return;

    }

    sessionStorage.setItem("owner", owner);
    sessionStorage.setItem("phone", phone);
    sessionStorage.setItem("address", address);
    sessionStorage.setItem("addressDetail", addressDetail);
    sessionStorage.setItem("companySerial", isCompany === 'company' ? companySerial : '');
    sessionStorage.setItem("receiptName", String(receiptName));
    sessionStorage.setItem("email", email);
    sessionStorage.setItem("postCode", postCode);
    sessionStorage.setItem("isInfoAgree", String(isInfoAgree));
    sessionStorage.setItem("closedDays", closedDays.join(','));
    sessionStorage.setItem("customerRequest", customerRequest);

    if (rememberMyInfo) {
      localStorage.setItem("owner", owner);
      localStorage.setItem("phone", phone);
      localStorage.setItem("address", address);
      localStorage.setItem("addressDetail", addressDetail);
      localStorage.setItem("companySerial", isCompany === 'company' ? companySerial : '');
      localStorage.setItem("receiptName", String(receiptName));
      localStorage.setItem("email", email);
      localStorage.setItem("postCode", postCode);
      localStorage.setItem("isInfoAgree", String(isInfoAgree));
      localStorage.setItem("closedDays", closedDays.join(','));
      localStorage.setItem("customerRequest", customerRequest);
    }

    const handleSubmit = async () => {
      const formData = new FormData();

      const today = new Date();
      formData.append('receiptName', receiptName);
      formData.append('phoneNumber', phone);
      formData.append('address', address)
      formData.append('addressDetail', addressDetail)

      try {
        const response = await axios.post(`${apiEndpoint}/receiption/api/onReceipt/`, formData, {
          headers: { 'Content-Type': 'multipart/form-data' },
        });

        const { success, onReceipt, data } = response.data;

        if (onReceipt) {
          sessionStorage.setItem('onReceipt', data[0].id);
        }
      } catch (error) {
        console.error('API 호출 중 오류 발생:', error);
      }
    };

    handleSubmit();
    navigate('/models/');
  }

  useEffect(() => {

    const savedOwner = localStorage.getItem(`owner`);
    if (savedOwner) {
      setOwner(savedOwner);
    }

    const savedCompanySerial = localStorage.getItem(`companySerial`);
    if (savedCompanySerial) {
      setCompanySerial(savedCompanySerial);
      const isValid = savedCompanySerial.length === 10 && /^\d+$/.test(savedCompanySerial);
      if (isValid) {
        setIsValidCompanyRegisterNumber(true)
      }
    }

    const savedEmail = localStorage.getItem('email');
    if (savedEmail) {
      setEmail(savedEmail);
    }

    const savedPhone = localStorage.getItem(`phone`);
    if (savedPhone) {
      setPhone(savedPhone);
    }

    const savedAddress = localStorage.getItem(`address`);
    if (savedAddress) {
      setAddress(savedAddress);
    }

    const savedAddressDetail = localStorage.getItem(`addressDetail`);
    if (savedAddressDetail) {
      setAddressDetail(savedAddressDetail);
    }

    const savedPostCode = localStorage.getItem(`postCode`);
    if (savedPostCode) {
      setPostCode(savedPostCode);
    }

    const savedRememberMyInfo = localStorage.getItem(`rememberMyInfo`) === 'true' ? true : false;
    if (savedRememberMyInfo) {
      setRememberMyInfo(savedRememberMyInfo);
    }

    const receiptName = localStorage.getItem(`receiptName`);
    if (receiptName) {
      setReceiptName(receiptName);
    }

    const savedCustomerRequest = localStorage.getItem(`customerRequest`);
    if (savedCustomerRequest) {
      setCustomerRequest(savedCustomerRequest);
    }

    const isAlready = document.getElementById(daumAddressId);

    if (!isAlready) {
      const script = document.createElement("script");
      script.src = daumAddressIdSrc;
      script.id = daumAddressId;
      document.body.append(script);
    }

    const savedClosedDays = localStorage.getItem('closedDays');
    if (savedClosedDays) {
      setClosedDays(savedClosedDays.split(','));
    }

    axios.get('https://geolocation-db.com/json/')
    .then((res) => {
      const ipAddress = res.data.IPv4;
      localStorage.setItem('ip', ipAddress);
      localStorage.setItem('connectLocation',`${res.data.state} ${res.data.city}`)
      return axios.get(`https://ipapi.co/${ipAddress}/json/`);
    })
    .catch((err) => {
      console.error('Error:', err);
    });

    // 세션 저장소에 시작 시간이 없으면 현재 시간을 저장
    if (!sessionStorage.getItem('sessionStartTime')) {
      const startTime = new Date().toISOString();
      sessionStorage.setItem('sessionStartTime', startTime);
    }

    sessionStorage.removeItem('savedCompanyRegisterPaper')
    sessionStorage.removeItem('onReceipt')
  }, []);


  const handleTelInputChange = (e: String) => {
    let input = e.replace(/\D/g, ''); // Remove all non-digit characters
    setPhone(input);
  };

  const handleCompanyNumberInputChange = (e: any) => {
    const value = e.target.value.replace(/\D/g, '') // Remove all non-digit characters

    if (!isNaN(e.target.value.slice(-1))){
      setCompanySerial(value);
      setIsRegistered(false)
    }

    const isValid = value.length === 10 && /^\d+$/.test(value);
    const isRepeated = /^(\d)\1{9}$/.test(value);
    const finalValidation = isValid && !isRepeated;

    if (finalValidation) {
      setIsValidCompanyRegisterNumber(true)
      console.log('valid company number')
    } else {
      setIsValidCompanyRegisterNumber(false)
      console.log('not valid company number')
    }
  };

  const loadLayout = () => {
    window.daum.postcode.load(() => {
      const postcode = new window.daum.Postcode({
        oncomplete: function (data) {
          console.log(data);
          setAddress(data.address)
          setPostCode(String(data.zonecode))
        }
      });
      postcode.open();

    });
  };

  const popupContent = (
    <div><span className="emphasis">"세금계산서 수신 용"</span> 이메일 주소를 입력해주세요.</div>
  )

  const handleIsCompanyToggleButton = (e: FormEvent<HTMLInputElement>, data: CheckboxProps) => {
    const checkedValue = data.value
    if (checkedValue === 'notCompany') {
      // 개인인 경우(사업자등록번호 없음)
      setIsRegistered(true)
      setIsCompany('notCompany');

      document.getElementById('companySerial')?.setAttribute('disabled', 'disabled');
      document.getElementById('validCompanySerial')?.classList.add('hidden');
      document.getElementById('validCompanySerial2')?.classList.add('hidden');

      setIsValidCompanyRegisterNumber(false)

    } else {
      setIsRegistered(false)

      setIsCompany('company');
      document.getElementById('companySerial')?.removeAttribute('disabled');

      const isValid = companySerial.length === 10 && /^\d+$/.test(companySerial);
      const isRepeated = /^(\d)\1{9}$/.test(companySerial);
      const finalValidation = isValid && !isRepeated;

      if (finalValidation){
        setIsValidCompanyRegisterNumber(true)
      } else {
        setIsValidCompanyRegisterNumber(false)
      }
    }
  }

  function companySerialonBlurHandler(event: any): void {
    const value = event.target.value.replace(/-/g, '');
    const isValid = value.length === 10 && /^\d+$/.test(value);

    if (!isValid) {
      document.getElementById('validCompanySerial')?.classList.remove('hidden');
      document.getElementById('validCompanySerial2')?.classList.add('hidden');
      setIsRegistered(false)

      setIsCompanySerialShake(true);
      setTimeout(() => {
        setIsCompanySerialShake(false);
      }, 500)
    } else {
      document.getElementById('validCompanySerial')?.classList.add('hidden');
    }
  }

  function emailonBlurHandler(event: any): void {
    const emailValue = event.target.value;
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!emailRegex.test(emailValue)) {
      document.getElementById('validEmail')?.classList.remove('hidden');

      setIsEmailShake(true); // Trigger shake animation

      setTimeout(() => {
        setIsEmailShake(false); // Reset shake animation
      }, 500);
    } else {
      document.getElementById('validEmail')?.classList.add('hidden');
    }
  }

  const searchCompanyNumber = (e:any) => {
    if (isCompany === 'company') {

      if (sessionStorage.getItem('savedCompanyRegisterPaper')) {
        document.getElementById('validCompanySerial2')?.classList.add('hidden');
        setIsRegistered(true)
      }

      // 여기서 API 호출하여 DB에 사업자번호에 해당하는 고객이 등록되어 있는지 확인
      else if (companySerial) {
        axios.get(`${apiEndpoint}/receiption/api/companySerial/${companySerial}`)
        .then(response => {

          if (response.data.isRegistered) {
            // DB에 사업자번호가 조회되는 경우
            document.getElementById('validCompanySerial2')?.classList.add('hidden');
            setIsRegistered(true)

          } else {
            // DB에 사업자번호로 조회되지 않는 경우
            document.getElementById('validCompanySerial2')?.classList.remove('hidden');
            setIsRegistered(false)


          }
        })
        .catch(error => {
          console.error('API 호출 중 오류 발생:', error);
        });

      } else {
        alert('사업자등록번호를 입력해주세요') //todo 추후 UI 통일해야함
      }

      // 사업자번호 조회

    } else {
      // 개인고객인 경우 사업자번호 조회 필요 없음!
    }
  }


  // 이미지를 sessionStorage에 저장하는 함수
  const uploadCompnaySerial = async () => {

    function toBase64(file: File): Promise<string> {
      return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.readAsDataURL(file);
          reader.onload = () => resolve(reader.result as string);
          reader.onerror = error => reject(error);
      });
    }

    const input = document.getElementById('companyRegisterPaperImage') as HTMLInputElement;
      if (input.files && input.files[0]) {
          const file = input.files[0];
          try {
              const savedCompanyRegisterPaper = await toBase64(file)
              sessionStorage.setItem('savedCompanyRegisterPaper', savedCompanyRegisterPaper);

              setIsUploadCompanySerial(true)
              setIsRegistered(true)

              document.getElementById('validCompanySerial')?.classList.add('hidden');
              document.getElementById('validCompanySerial2')?.classList.add('hidden');

              alert('정상적으로 저장되었습니다. \n페이지 이탈 시 처음부터 다시 시작하게 됩니다. 이어서 진행해주세요!');

              console.log(file)
          } catch (error) {
              console.error('Error converting image to Base64:', error);

          }
      } else {
          // alert('Error : 이미지를 업로드해주세요!');
      }
      setIsRegistered(true)
      document.getElementById('validCompanySerial2')?.classList.add('hidden');

  }


  const genClosedDaySelector = () => {

    const days: string[] = ['월', '화', '수', '목', '금'];
    const toggleDay = (day:string): void => {
      if (closedDays.includes(day)) {
        // 이미 선택된 경우 선택 해제
        setClosedDays(closedDays.filter((d) => d !== day));
      } else {
        // 선택되지 않은 경우 선택 추가
        setClosedDays([...closedDays, day]);
      }
    };

    return (
      <>
        <div>
          <p className="emphasis" style={{ fontSize: 'small'}}>* A/S기사 배정 시 해당 요일 제외 후 배정됩니다.<span className="emphasis-blue">{closedDays.length === 0 ? '' : ` (선택된 휴무요일: ${closedDays.join(', ')})`}</span></p>

        </div>
        <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
          {days.map((day) => (
            <Button
              key={day}
              size="mini"
              onClick={() => toggleDay(day)}
              color={closedDays.includes(day) ? undefined : 'orange'} // 선택된 경우 오렌지색
              style={{ flex: 'auto' }}
            >
              {day}
            </Button>
          ))}
        </div>


      </>
    )
  }


  const genCustomerRequestForm = () => {
    return (
      <>
        <div style={{ display: 'flex', justifyContent: 'space-between', width: '100%' }}>
        <input
            placeholder="(예시) 방문 2일 전 출입신청 필요함, 사업자등록증 발급 전으로 추후 전달함"
            type="text"
            name="customerRequest"
            id="customerRequest"
            className="col-6"
            onChange={(e) => {
              setCustomerRequest(e.target.value);
            }}
            value={customerRequest}
          />
        </div>
      </>
    )
  }
  // paymentText 중 "카드 결제"라는 단어를 굵게(bold) 표시하려면,
  // paymentText의 출력에 <b>...</b> 혹은 <strong>...</strong> 태그로 감싸고,
  // TextArea 대신 React에서 HTML을 렌더링하게 dangerouslySetInnerHTML을 쓰거나,
  // TextArea 대신 <div> 등으로 보여줘야 합니다.

  // 1. [Step 1] 카드 결제 문구를 bold 태그로 감싼 paymentTextHtml 생성
  const paymentTextHtml = `
안녕하세요, 고객님.<br>
저희 디랙스을 이용해 주셔서 감사합니다.<br>
2025년 3월 10일 (월)부터 A/S 서비스 결제 관련하여 변경이 되오니 안내해 드립니다.<br><br>
<b>* 결제 방법</b><br>
결제는 <b>카드 결제</b>를 통해 가능합니다.<br>
결제는 A/S 서비스 제공 당일에 완료해 주셔야 합니다.<br><br>
<b>* 당일 결제가 안될 경우</b><br>
엔지니어 방문시 <b>카드결제</b>가 준비가 안 될 경우 서비스가 제한이 될 수 있으며, 출장비(44,000원)이 부과 됩니다.
<br><br>
고객님께 보다 나은 서비스를 제공하기 위해 항상 노력하겠습니다.<br>
추가적인 문의 사항이 있으시면 언제든지 고객센터로 문의해 주세요.<br><br>
감사합니다.
`;

  const agreementText = `[출장 서비스 예약 개인정보 수집 이용 동의]

주식회사 디랙스(이하 ‘회사’라 한다)는 개인정보 보호법 제30조에 따라 정보 주체의 개인정보를 보호하고 이와 관련한 고충을 신속하고 원활하게 처리할 수 있도록 하기 위하여 다음과 같이 개인정보 처리지침을 수립, 공개합니다.

제1조 (개인정보의 처리목적) 회사는 다음의 목적을 위하여 개인정보를 처리합니다. 처리하고 있는 개인정보는 다음의 목적 이외의 용도로는 이용되지 않으며, 이용 목적이 변경되는 경우에는 개인정보보호법 제18조에 따라 별도의 동의를 받는 등 필요한 조치를 이행할 예정입니다. 1. 홈페이지 회원 가입 및 관리 회원 가입 의사 확인, 회원제 서비스 제공에 따른 본인 식별․인증, 회원자격 유지․관리, 제한적 본인확인제 시행에 따른 본인확인, 서비스 부정 이용 방지, 만 14세 미만 아동의 개인정보처리 시 법정대리인의 동의 여부 확인, 각종 고지․통지, 고충 처리 등을 목적으로 개인정보를 처리합니다.

2. 재화 또는 서비스 제공 물품 배송, 서비스 제공, 계약서 및 청구서 발송, 콘텐츠 제공, 맞춤서비스 제공, 본인인증, 연령인증, 요금 결제 및 정산, 채권추심 등을 목적으로 개인정보를 처리합니다.

3. 고충 처리 민원인의 신원 확인, 민원사항 확인, 사실조사를 위한 연락․통지, 처리 결과 통보 등의 목적으로 개인정보를 처리합니다.

제2조 (개인정보의 처리 및 보유기간) ① 회사는 법령에 따른 개인정보 보유, 이용 기간 또는 정보주체로부터 개인정보를 수집 시에 동의 받은 개인정보 보유, 이용 기간 내에서 개인정보를 처리, 보유합니다. ② 각각의 개인정보 처리 및 보유 기간은 다음과 같습니다.

1. 홈페이지 회원 가입 및 관리 : 사업자/단체 홈페이지 탈퇴 시까지 다만, 다음의 사유에 해당하는 경우에는 해당 사유 종료 시까지 1) 관계 법령 위반에 따른 수사, 조사 등이 진행 중인 경우에는 해당 수사, 조사 종료 시까지 2) 홈페이지 이용에 따른 채권 및 채무관계 잔존 시에는 해당 채권, 채무 관계 정산 시까지

2. 재화 또는 서비스 제공 : 재화․서비스 공급완료 및 요금결제․정산 완료 시까지 다만, 다음의 사유에 해당하는 경우에는 해당 기간 종료 시까지 1) 「전자상거래 등에서의 소비자 보호에 관한 법률」에 따른 표시․광고, 계약내용 및 이행 등 거래에 관한 기록 - 표시․광고에 관한 기록 : 6개월 - 계약 또는 청약 철회, 대금결제, 재화 등의 공급기록 : 5년 - 소비자 불만 또는 분쟁 처리에 관한 기록 : 3년 2) 「통신비밀보호법」 제41조에 따른 통신사실확인자료 보관 - 가입자 전기통신일시, 개시․종료 시간, 상대방 가입자 번호, 사용도수, 발신기지국 위치추적자료 : 1년 - 컴퓨터 통신, 인터넷 로그 기록자료, 접속지 추적자료 : 3개월

제3조 (개인정보의 제3자 제공) ① 회사는 정보주체의 개인정보를 제1조(개인정보의 처리목적)에서 명시한 범위 내에서만 처리하며, 정보주체의 동의, 법률의 특별한 규정 등 개인정보 보호법 제17조에 해당하는 경우에만 개인정보를 제3자에게 제공합니다. ② 회사는 다음과 같이 개인정보를 제3자에게 제공하고 있습니다. - 개인정보를 제공받는 자 : 피알게이트 주식회사 - 제공받는 자의 개인정보 이용목적 : 참가 신청 확인 등 업무제휴 - 제공하는 개인정보 항목 : 성명, 주소, 전화번호, 이메일주소 - 제공받는 자의 보유, 이용기간 : 신청 후 6개월

제5조(이용자 및 법정대리인의 권리와 그 행사 방법)

① 정보주체는 회사에 대해 언제든지 다음 각 호의 개인정보 보호 관련 권리를 행사할 수 있습니다. 1. 개인정보 열람 요구 2. 오류 등이 있을 경우 정정 요구 3. 삭제요구 4. 처리정지 요구 ② 제1항에 따른 권리 행사는 회사에 대해 서면, 전화, 전자우편, 모사전송(FAX) 등을 통하여 하실 수 있으며 회사는 이에 대해 지체없이 조치하겠습니다. ③ 정보주체가 개인정보의 오류 등에 대한 정정 또는 삭제를 요구한 경우에는 회사는 정정 또는 삭제를 완료할 때까지 당해 개인정보를 이용하거나 제공하지 않습니다. ④ 제1항에 따른 권리 행사는 정보주체의 법정대리인이나 위임을 받은 자 등 대리인을 통하여 하실 수 있습니다. 이 경우 개인정보 보호법 시행규칙 별지 제11호 서식에 따른 위임장을 제출하셔야 합니다. ⑤ 정보주체는 개인정보 보호법 등 관계 법령을 위반하여 회사가 처리하고 있는 정보주체 본인이나 타인의 개인정보 및 사생활을 침해하여서는 아니 됩니다.

제6조(처리하는 개인정보 항목) 회사는 다음의 개인정보 항목을 처리하고 있습니다.

1. 홈페이지 회원 가입 및 관리 필수항목 : 이메일, 비밀번호, 성명, 전화번호, 주소, 생년월일

2. 재화 또는 서비스 제공 필수항목 : 성명, 생년월일, 아이디, 비밀번호, 주소, 전화번호, 이메일주소, 신용카드번호, 은행계좌정보 등 결제정보

3. 인터넷 서비스 이용과정에서 아래 개인정보 항목이 자동으로 생성되어 수집될 수 있습니다. IP주소, 쿠키, MAC주소, 서비스 이용기록, 방문기록, 불량 이용기록 등

제7조(개인정보의 파기) ① 회사는 개인정보 보유 기간의 경과, 처리목적 달성 등 개인정보가 불필요하게 되었을 때에는 지체없이 해당 개인정보를 파기합니다. ② 정보주체로부터 동의받은 개인정보 보유 기간이 경과하거나 처리목적이 달성되었음에도 불구하고 다른 법령에 따라 개인정보를 계속 보존하여야 하는 경우에는, 해당 개인정보를 별도의 데이터베이스(DB)로 옮기거나 보관장소를 달리하여 보존합니다. ③ 개인정보 파기의 절차 및 방법은 다음과 같습니다. 1. 파기 절차 회사는 파기 사유가 발생한 개인정보를 선정하고, 회사의 개인정보 보호책임자의 승인을 받아 개인정보를 파기합니다. 2. 파기 방법 회사는 전자적 파일 형태로 기록․저장된 개인정보는 기록을 재생할 수 없도록 로우레밸포멧(Low Level Format) 등의 방법을 이용하여 파기하며, 종이 문서에 기록․저장된 개인정보는 분쇄기로 분쇄하거나 소각하여 파기합니다.

제8조(개인정보의 안전성 확보조치) 회사는 개인정보의 안전성 확보를 위해 다음과 같은 조치를 하고 있습니다. 1. 관리적 조치 : 내부관리계획 수립 및 시행, 정기적 직원 교육 등 2. 기술적 조치 : 개인정보처리시스템 등의 접근 권한 관리, 접근통제시스템 설치, 고유 식별정보 등의 암호화, 보안프로그램 설치 3. 물리적 조치 : 전산실, 자료보관실 등의 접근통제

제9조(개인정보 자동 수집 장치의 설치∙운영 및 거부에 관한 사항) ① 회사는 이용자에게 개별적인 맞춤 서비스를 제공하기 위해 이용정보를 저장하고 수시로 불러오는 ‘쿠키(cookie)’를 사용합니다. ② 쿠키는 웹사이트를 운영하는데 이용되는 서버(http)가 이용자의 컴퓨터 브라우저에 보내는 소량의 정보이며 이용자들의 컴퓨터 내의 하드디스크에 저장되기도 합니다. 가. 쿠키의 사용 목적: 이용자가 방문한 각 서비스와 웹 사이트들에 대한 방문 및 이용형태, 인기 검색어, 보안접속 여부, 등을 파악하여 이용자에게 최적화된 정보 제공을 위해 사용됩니다. 나. 쿠키의 설치∙운영 및 거부 : 웹브라우저 상단의 도구>인터넷 옵션>개인정보 메뉴의 옵션 설정을 통해 쿠키 저장을 거부 할 수 있습니다. 다. 쿠키 저장을 거부할 경우 맞춤형 서비스 이용에 어려움이 발생할 수 있습니다.

제10조(개인정보 보호책임자) ① 회사는 개인정보 처리에 관한 업무를 총괄해서 책임지고, 개인정보 처리와 관련한 정보주체의 불만 처리 및 피해구제 등을 위하여 아래와 같이 개인정보 보호책임자를 지정하고 있습니다.

▶ 개인정보 보호책임자 성명 : 유선경 직책 : 대표 연락처 : Tel.02-569-9924 Fax.031-459-8531 ※ 개인정보 보호 담당부서로 연결됩니다.

▶ 개인정보 보호 담당부서 부서명 : 디랙스 담당자 : 유선경 연락처 : Tel.02-459-8530 Fax.031-459-8531

② 정보주체께서는 회사의 서비스(또는 사업)을 이용하시면서 발생한 모든 개인정보 보호 관련 문의, 불만 처리, 피해구제 등에 관한 사항을 개인정보 보호책임자 및 담당부서로 문의하실 수 있습니다. 회사는 정보주체의 문의에 대해 지체없이 답변 및 처리해드릴 것입니다.

제11조(개인정보 열람청구) 정보주체는 개인정보 보호법 제35조에 따른 개인정보의 열람 청구를 아래의 부서에 할 수 있습니다. 회사는 정보주체의 개인정보 열람 청구가 신속하게 처리되도록 노력하겠습니다.

▶ 개인정보 열람청구 접수․처리 부서 부서명 : 디랙스 담당자 : 유선경 연락처 : Tel.02-459-8530 Fax.031-459-8531

제12조(권익침해 구제 방법) 정보주체는 아래의 기관에 대해 개인정보 침해에 대한 피해구제, 상담 등을 문의하실 수 있습니다.

▶ 개인정보 침해신고센터 (한국인터넷진흥원 운영) - 소관 업무 : 개인정보 침해사실 신고, 상담 신청 - 홈페이지 : privacy.kisa.or.kr - 전화 : (국번없이) 118 - 주소 : (58324) 전남 나주시 진흥길 9(빛가람동 301-2) 3층 개인정보침해신고센터

▶ 개인정보 분쟁조정위원회 - 소관업무 : 개인정보 분쟁조정신청, 집단분쟁조정 (민사적 해결) - 홈페이지 : www.kopico.go.kr - 전화 : (국번없이) 1833-6972 - 주소 : (03171)서울특별시 종로구 세종대로 209 정부서울청사 4층

▶ 대검찰청 사이버범죄수사단 : 02-3480-3573 (www.spo.go.kr) ▶ 경찰청 사이버안전국 : 182 (http://cyberbureau.police.go.kr)

제13조(개인정보 처리방침 시행 및 변경) 이 개인정보 처리방침은 사이트 게시일부터 적용됩니다.`

  return (
    <>
      <div className="card p-4">
        {/* <SelfCheckConfirm/> */}
        <h3 className="align-center mt-2 mb-4">고객 정보</h3>
        <div className="align-left" style={{ fontStyle: "italic", fontSize: "small" }}>
          (필수입력<EssentialStar /> )
          </div>
        <Form>
          <FormField className={`${isOwnerShake ? 'shake' : ''}`}>
          <div className={`bold align-left `}>
            <label>고객명/ 상호명 <EssentialStar /></label>
          </div>
            <input
            placeholder='고객명/상호명'
            type="text"
            name="ownerName"
            id="ownerName"
            className="col-6"
            onChange={(e) => {
              setOwner(e.target.value);
            }}
            value={owner}
          />
          </FormField>

          <FormField className={`${isCompanySerialShake ? 'shake' : ''}`}>
            <div className={`bold align-left`}>
              <label>사업자등록번호<EssentialStar/></label>
            </div>
            <div className="flex p-1 ">
              <Checkbox
                radio
                className="m-1 small"
                label='사업자/ 아파트조합/ 관공서 '
                name='checkboxRadioGroup'
                value='company'
                checked={isCompany === 'company'}
                onChange={handleIsCompanyToggleButton}
              />
              <Checkbox
                radio
                className="m-1 small"
                label='개인'
                name='checkboxRadioGroup'
                value='notCompany'
                checked={isCompany === 'notCompany'}
                onChange={handleIsCompanyToggleButton}
              />
            </div>
            <div className="row">
              <div className="col-8">
                <input
                  placeholder='사업자등록번호'
                  type="text"
                  name="companySerial"
                  id="companySerial"
                  onChange={handleCompanyNumberInputChange}
                  onBlur={companySerialonBlurHandler}
                  value={companySerial}
                  maxLength={10}
                />
              </div>
              <div className="col-4">

                <Button className="col-12" onClick={searchCompanyNumber} disabled={isValidCompanyRegisterNumber?false:true} size="tiny">
                  조회
                </Button>
              </div>

            </div>
            <div id="validCompanySerial" className="align-left emphasis hidden" style={{ fontStyle: "italic", fontSize: "small"}}>
              * 올바른 사업자 번호를 입력해주세요(10자리)
            </div>
            <div id="validCompanySerial2" className="align-left emphasis hidden row p-1" style={{ fontStyle: "italic", fontSize: "small"}}>
              <div className="col-8">
                * 고객정보가 조회되지 않습니다. 사업자등록증을 업로드해주세요
              </div>
              <div className="col-3">
                <Button color='orange' size='tiny' as="label" htmlFor={`companyRegisterPaperImage`} type="button" disabled={isCompany === 'notCompany'} icon>
                  <Icon name='file outline'></Icon><span style={{ fontSize:'0.75rem' }}>업로드</span>
                </Button>
              </div>
              <input
                type="file"
                accept="image/*"
                id={`companyRegisterPaperImage`}
                style={{ display: "none" }}
                onChange={uploadCompnaySerial}
              />
            </div>

            <div id="confirmCompnaySerial" className={`align-left emphasis ${isRegistered && isCompany === 'company' ? '' : 'hidden'} row p-1`} style={{ fontStyle: "italic", fontSize: "small"}}>
              <div>
                * 고객정보 확인 완료되었습니다!
              </div>
            </div>
          </FormField>

          <FormField disabled={isRegistered ? false : true}>
            <div className={`bold align-left `}>
              <label>정기휴무요일/ 기피요일</label>
            </div>
            {genClosedDaySelector()}
          </FormField>

          <FormField disabled={isRegistered ? false : true}>
            <div className={`bold align-left `}>
              <label>고객 요청사항</label>
            </div>
            {genCustomerRequestForm()}
          </FormField>

          <FormField disabled={isRegistered ? false : true} className={`${isEmailShake ? 'shake' : ''}`}>
          <div className={`bold align-left `}>
            <label>
              <Popup
                content={popupContent}
                trigger={<span>이메일</span>}
                style={{padding:'0.75em', fontWeight:"bold", backgroundColor:'#f8f8f8'}}
                size='mini'
                />
              <EssentialStar /></label>
            </div>
            <input
            placeholder='세금계산서용 이메일을 입력해주세요'
            id="email"
            onChange={(e) => {setEmail(e.target.value);}}
            // onBlur={emailonBlurHandler}
            value={email}
          />
          <div id="validEmail" className="align-left emphasis hidden" style={{ fontStyle: "italic", fontSize: "small"}}>* 올바른 이메일주소를 입력해주세요</div>
          </FormField>

          <FormField disabled={isRegistered ? false : true} className={`${isReceiptNameShake ? 'shake' : ''}`}>
            <div className={`bold `}>
              <label>접수자 이름<EssentialStar/></label>
            </div>
            <input
            placeholder='접수자 이름'
            name="receipt_name"
            id="receipt_name"
            onChange={(e) => setReceiptName(e.target.value)}
            value={receiptName}
              />
          </FormField>
          <FormField disabled={isRegistered ? false : true} className={`${isPhoneShake ? 'shake' : ''}`}>
            <div className={`bold `}>
              <label>연락처<EssentialStar/></label>
            </div>
            <input
            placeholder='알림톡을 위한 연락처를 입력해주세요.'
            name="phone_number"
            id="phone"
            onChange={(e) => handleTelInputChange(e.target.value)}
            value={phone}
              />
          </FormField>
          <FormField disabled={isRegistered ? false : true} className={`${isAddressShake ? 'shake' : ''}`}>
            <div className={`bold `}>
              <label>주소<EssentialStar/></label>
            </div>
            <div className="row">
              <div className="col-9">
                <input
                  placeholder='우편번호'
                  disabled
                  name="postCode"
                  id="postCode"
                  value={postCode}
                  readOnly
                />
              </div>
              <div className="col-3">
                <Button className="col-12" onClick={loadLayout} size="mini">
                  검색
                </Button>
              </div>
            </div>

            <div>
              <input
                placeholder='주소'
                disabled
                name="address"
                id="address"
                value={address}
                readOnly
                />
            </div>
            <div>
              <input
                placeholder='상세주소'
                name="address_detail"
                id="address_detail"
                onChange={(e) => {setAddressDetail(e.target.value);}}
                value={addressDetail}
                />
            </div>
          </FormField>
          <FormField disabled={isRegistered ? false : true} className={`${isInfoShake ? 'shake' : ''}`}>
          <div className={`bold `} style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
            <label>개인정보제공동의 <EssentialStar/></label>
            <Button size="mini" className={'my-1'} onClick={() => setOpen(true)}>전문보기</Button>
          </div>
          <div>
          <TextArea
              value={agreementText}
              rows={4}
              readOnly
              style={{
                width: "100%",
                overflowY: "auto",
                resize: "none",
                border: "1px solid #ccc",
                padding: "10px",
                fontSize: "0.9rem",
                color: "gray",
              }}
            />
          </div>
            <div className={`align-left my-1`}>
              <Checkbox
              label='동의합니다.'
              checked={isInfoAgree}
              onChange={(e,data) => setIsInfoAgree(data.checked || false)}/>
            </div>
          </FormField>
        </Form>

      </div>
      <div className="align-right pb-4">
          <Checkbox
            label='내정보 기억하기'
            checked={rememberMyInfo}
            onChange={(e,data) => {
              setRememberMyInfo(data.checked || false)
              localStorage.setItem('rememberMyInfo', data.checked ? 'true' : 'false')
            }}
          />
        </div>
      <div className="row">
        <div className="col-3" />
        <div className="align-center col-6">
          <Button style={{ backgroundColor: '#F2711C', color: 'white' }} className="p-3" onClick={handleNextButtonClick}>다음으로</Button>
        </div>
        <div className="col-3" />
      </div>

      {/* 개인정보 제공 동의 전문 모달 */}
      <Modal
        open={open}
        onClose={() => setOpen(false)}
        size="small"
      >
        <Modal.Header>개인정보 수집 및 이용 동의 전문</Modal.Header>
        <Modal.Content>
          <TextArea
            value={agreementText}
            rows={35}
            readOnly
            style={{
              width: "100%",
              overflowY: "auto",
              resize: "none",
              border: "1px solid #ccc",
              padding: "10px",
              fontSize: "0.9rem",
            }}
          />
        </Modal.Content>
        <Modal.Actions>
          <Button onClick={() => setOpen(false)}>닫기</Button>
        </Modal.Actions>
      </Modal>
      <Modal
        open={paymentOpen}
        onClose={() => setPaymentOpen(false)}
        size="small"
      >
        <Modal.Header>서비스 비용 관련 안내사항</Modal.Header>
        <Modal.Content>
          <div
            style={{
              width: "100%",
              overflowY: "auto",
              resize: "none",
              border: "1px solid #ccc",
              padding: "10px",
              fontSize: "0.9rem",
              minHeight: "300px",
              whiteSpace: "pre-line",
              background: "#FAFAFA"
            }}
            dangerouslySetInnerHTML={{ __html: paymentTextHtml }}
          />
        </Modal.Content>
        <Checkbox
          label='동의합니다'
          checked={isPaymentAgree}
          onChange={(e,data) => setIsPaymentAgree(data.checked || false)}
          style={{
            marginLeft: '1em',
            marginBottom: '1em' ,
            padding: "10px",
          }}
          />

        <Modal.Actions>
        <Button
            onClick={() => {
              if (!isPaymentAgree) {
                alert('동의에 체크해주세요');
                return;
              }
              setPaymentOpen(false);
            }}
          >
            닫기
          </Button>
        </Modal.Actions>
      </Modal>
    </>
  );
}

export default InputCustomerInfo;
